import React from 'react';
import { Club } from '../../API/clubs/club.interface';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store.interface';
import { CheckClubProps } from './checkClub.interface';
import { loadingStyles } from '../../styles';
import { Helmet } from 'react-helmet';

export const getManifest = (club: Club): string => {
  if (
    club.parkingManifest &&
    club.parkingDomain &&
    window.location.hostname.indexOf(club.parkingDomain) !== -1
  ) {
    const parts = window.location.hostname.split('.');
    if (parts[0] === 'www' && club.parkingManifestWithWWW) {
      return club.parkingManifestWithWWW;
    }

    return club.parkingManifest;
  }

  return club.manifest;
};

const CheckClub = ({ children }: CheckClubProps): JSX.Element => {
  const club: Club = useSelector((state: RootState) => state.club);
  if (Object.keys(club).length === 0) {
    return (
      <div className="row" style={loadingStyles}>
        <div className="loader-bubble loader-bubble-info m-6"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{club.name} | Sistema Nube</title>
        <link rel="manifest" href={getManifest(club)} />
        <link rel="icon" href={club.icon} />
        <style>{club.styles.frontClient}</style>
      </Helmet>
      {children}
    </>
  );
};

export default CheckClub;
